type GetCropMinWidth = (cropContainerSize: number, imageWidth: number, imageHeight: number, minWidth: number) => number;

export const getCropMinWidth: GetCropMinWidth = (cropContainerSize, imageWidth, imageHeight, minWidth) => {
    let minCropWidth = cropContainerSize;
    const imageAspect = imageWidth / imageHeight;
    if (imageHeight < imageWidth) {
        if (cropContainerSize >= imageWidth) {
            return minWidth;
        }
        minCropWidth = cropContainerSize / (imageWidth / minWidth);
    } else if (imageHeight >= imageWidth) {
        if (cropContainerSize >= imageHeight) {
            return minWidth;
        }
        minCropWidth = (cropContainerSize * imageAspect) / (imageWidth / minWidth);
    }

    return Math.ceil(minCropWidth);
};

/**
 * В bottom sheet получаем ситуацию, когда есть скроллящийся контейнер с кропами
 * и отдельные кропы, которые мы тоже можем двигать.
 * Поэтому необходимо блокировать скролл контейнера с кропами при перемещении непосредственно кропа
 */
export const setupCropContainerScrollBlock = (container: HTMLElement): (() => void) => {
    let isDraggingCrop = false;

    const handleTouchStart = (e: TouchEvent) => {
        const target = e.target as HTMLElement;

        const cropElement = target.closest('[class*="ReactCrop__crop-selection"]');
        if (cropElement) {
            isDraggingCrop = true;
            container.style.overflow = 'hidden';
            container.style.touchAction = 'none';
        }
    };

    const handleTouchMove = (e: TouchEvent) => {
        if (isDraggingCrop) {
            e.preventDefault();
            e.stopPropagation();
        }
    };

    const handleTouchEnd = () => {
        if (isDraggingCrop) {
            isDraggingCrop = false;
            container.style.overflow = '';
            container.style.touchAction = '';
        }
    };

    container.addEventListener('touchstart', handleTouchStart, { passive: false, capture: true });
    container.addEventListener('touchmove', handleTouchMove, { passive: false, capture: true });
    container.addEventListener('touchend', handleTouchEnd, { passive: true, capture: true });
    container.addEventListener('touchcancel', handleTouchEnd, { passive: true, capture: true });

    return () => {
        container.removeEventListener('touchstart', handleTouchStart, { capture: true });
        container.removeEventListener('touchmove', handleTouchMove, { capture: true });
        container.removeEventListener('touchend', handleTouchEnd, { capture: true });
        container.removeEventListener('touchcancel', handleTouchEnd, { capture: true });

        container.style.overflow = '';
        container.style.touchAction = '';
    };
};
